// Rules for music kept on a device for offline listening, the same on the
// website and in the phone app (docs/REVENUE_SPLITS.md):
// - Music the listener owns (bought, or worked on) plays offline freely.
// - Other music plays offline only while the balance the device last saw
//   online covers it, and only if it checked in within the last 30 days.
//   Those plays are charged when they're sent, once back online.

export const CHECK_IN_DAYS = 30;
const CHECK_IN_MS = CHECK_IN_DAYS * 24 * 3600 * 1000;
// Enough credit left for at least this much listening
const MINIMUM_SECONDS = 30;

// allowance: { balance, rate, checkedAt } from /music/offline-allowance/
export const canPlayOffline = (entry, allowance, now = Date.now()) => {
  if (!entry) return false;
  if (entry.owned) return true;
  if (!allowance) return false;
  const fresh = now - allowance.checkedAt < CHECK_IN_MS;
  return fresh && allowance.balance > allowance.rate * MINIMUM_SECONDS;
};

// The allowance after an offline play of music they don't own, which will
// be charged when the play is sent
export const spendAllowance = (allowance, seconds) => ({
  ...allowance,
  balance: Math.max(0, allowance.balance - allowance.rate * seconds),
});

// From the server's reply: { credit_balance, rate_per_second }
export const allowanceFrom = ({ credit_balance: balance, rate_per_second: rate } = {}, now = Date.now()) => (
  balance === undefined || rate === undefined ? null : { balance, rate, checkedAt: now }
);
